import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { PageMenu } from '../../../../components'
import { IconCadastrosBlue } from '../../../../assets/imgs'
import NotAllowedModule from '../../../../components/NotAllowedModule/NotAllowedModule'
import {
  FiscalPermissions,
  menuItemsAllowed,
  TpPermissions,
  verifyTpPermission,
} from '../../../../services/permission/menus'

function CadastrosMenu({ selectedTp }) {
  const [allowed, setAllowed] = React.useState(true)

  useEffect(() => {
    const allowed = verifyTpPermission(TpPermissions.CADASTROS, selectedTp)
    setAllowed(allowed)
  }, [selectedTp])

  const menuItems = menuItemsAllowed([
    { id: 61, content: { menu: '2.1 - Clientes', path: '/main/cadastros/clientes' } },
    { id: 62, content: { menu: '2.2 - Produtos', path: '/main/cadastros/produtos' } },
    {
      id: 63,
      content: { menu: '2.3 - Grupo de Produtos', path: '/main/cadastros/grupo-produtos' },
    },
    {
      id: 64,
      content: { menu: '2.4 - Motoristas', path: '/main/cadastros/motoristas' },
    },
    { id: 65, content: { menu: '2.5 - Veículos', path: '/main/cadastros/veiculos' } },
    {
      id: 66,
      content: { menu: '2.6 - Rotas de Entrega', path: '/main/cadastros/rotas-entrega' },
    },
    {
      id: 67,
      content: {
        menu: '2.7 - Lista de Envio - Emails',
        path: '/main/cadastros/lista-envio-email',
      },
    },
    {
      id: 68,
      content: {
        menu: '2.8 - Lead Time Para Recebimento de Carga',
        path: '/main/cadastros/lead-time-recebimento-carga',
      },
    },
    {
      id: 28,
      content: { menu: '2.9 - Transportadoras', path: '/main/cadastros/transportadoras' },
    },
    {
      id: 69,
      content: {
        menu: '2.10 - Veiculo Transferência',
        path: '/main/cadastros/veiculo-transferencia',
      },
    },
    {
      id: 31,
      content: { menu: '2.11 - Motivos de Atraso', path: '/main/cadastros/motivo-atraso' },
    },
    {
      id: 70,
      content: { menu: '2.12 - Tipos de Veículos', path: '/main/cadastros/tipo-veiculo' },
    },
    {
      id: 71,
      content: { menu: '2.13 - Gestão de Empresas', path: '/main/cadastros/empresa' },
    },
    {
      id: 72,
      content: { menu: '2.14 - Seguradoras', path: '/main/cadastros/seguradoras' },
    },
    {
      id: 73,
      content: { menu: '2.15 - Regras de Frete', path: '/main/cadastros/regras-frete' },
    },
    {
      id: 45,
      content: { menu: '2.16 - Gestão de Usuários', path: '/main/cadastros/gestao-usuarios' },
    },
    {
      id: 74,
      content: { menu: '2.17 - Cadastro de Ajudante', path: '/main/cadastros/ajudantes' },
    },
    {
      id: 138,
      content: {
        menu: '2.18 - Analista de Monitoramento de Entregas',
        path: '/main/cadastros/analista-monitoramento-entregas',
      },
    },
    {
      id: 147,
      content: {
        menu: '2.19 - Cadastro Zona - Entregas',
        path: '/main/cadastros/zona-entregas',
      },
    },
    {
      id: 148,
      content: {
        menu: '2.20 - Cadastro de Ocorrências de Entrega',
        path: '/main/cadastros/ocorrencia-entrega',
      },
    },
    {
      id: FiscalPermissions.SERVICOS_NFSE,
      content: { menu: '2.21 - Serviços (NFS-e)', path: '/main/cadastros/servicos-nfse' },
    },
  ])

  return (
    <>
      <PageMenu menuItems={allowed ? menuItems : []}>
        <img src={IconCadastrosBlue} alt="Icon Tela de Cadastros" />
        <span style={{ display: 'inline-block', marginLeft: 10 }}>2. Cadastros</span>
      </PageMenu>
      {!allowed && <NotAllowedModule />}
    </>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(CadastrosMenu))
